import React, { useState } from "react";
import { HistoryFilterModel } from "../../../../shared/models/order/history-filter.model";
import { useAppSelector } from "../../../../../redux/store";
import { CustomerFilterModel } from "./customer-filter";
import BarekamInput from "../../../../components/input";
import { getMessage } from "../../../../shared/helper-functions";
import { MessageSections } from "../../../../components/message/message";

export const SearchInput = ({ filter, filterChanged }: SearchInputProps) => {
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const [textQuery, setTextQuery] = useState(filter.textQuery || '');

    const [searchTimeoutId, setSearchTimeoutId] = useState<any>();


    function onSearchQueryKeyUp(key: string) {
        if (key === 'Enter') {
            clearTimeout(searchTimeoutId);

            setFilterWithQuery();
        }
    }
    function setFilterWithQuery() {
        const filterClone = { ...filter };

        if (textQuery) {
            filterClone.textQuery = textQuery;
        } else {
            delete filterClone.textQuery;
        }

        filterChanged(filterClone);
    }

    function onSearchQueryChange(query: string) {
        setTextQuery(query);
        clearTimeout(searchTimeoutId);

        const newTimeoutId = setTimeout(() => {
            setFilterWithQuery();
        }, 3000);

        setSearchTimeoutId(newTimeoutId);
    }

    return (
        <BarekamInput customInputVariant={'search'}
            width={'20rem'}
            placeholder={getMessage('search', MessageSections.MAIN, messageCache, languageId)}
            value={textQuery || ''}
            onChange={(event) => onSearchQueryChange(event.target.value)}
            onKeyUp={(event) => onSearchQueryKeyUp(event.key)} />
    )
}

interface SearchInputProps {
    filter: CustomerFilterModel | HistoryFilterModel,
    filterChanged: (filter: CustomerFilterModel | HistoryFilterModel) => void;
}